/*
 * Gratis vare ved køb over et beløb – lægges i kurven af sig selv (Smibo / Happy Horse).
 *
 * The <hh-free-gift> element is rendered by snippets/hh-free-gift.liquid with the cart's state
 * on its data attributes and is re-rendered with the cart. Every time it appears it decides one
 * thing: if the other goods reach the threshold and the gift is not in the cart, add it; if they
 * do not and the gift was added by this script (line property _hh_gift), take it out again, so
 * nobody pays for a gift they did not choose. A gift the customer put in the cart themselves has
 * no property and is left alone – the automatic discount makes one of them free at the checkout.
 */
(function () {
  if (customElements.get('hh-free-gift')) return;

  let busy = false;

  class HHFreeGift extends HTMLElement {
    connectedCallback() {
      if (busy || !window.FoxTheme) return;
      const threshold = parseInt(this.dataset.threshold, 10) || 0;
      const eligible = parseInt(this.dataset.eligible, 10) || 0;
      const inCart = parseInt(this.dataset.inCart, 10) || 0;
      const autoLine = parseInt(this.dataset.autoLine, 10) || 0;
      const variantId = parseInt(this.dataset.variantId, 10) || 0;
      if (!variantId || threshold <= 0) return;

      if (eligible >= threshold && inCart === 0 && this.dataset.available === 'true') {
        this.add(variantId);
      } else if (eligible < threshold && autoLine > 0) {
        this.remove(autoLine);
      }
    }

    sections() {
      const sections = [];
      document.documentElement.dispatchEvent(
        new CustomEvent('cart:grouped-sections', { bubbles: true, detail: { sections } })
      );
      return sections;
    }

    add(variantId) {
      busy = true;
      const body = JSON.stringify({
        items: [{ id: variantId, quantity: 1, properties: { _hh_gift: '1' } }],
        sections: this.sections(),
      });
      fetch(FoxTheme.routes.cart_add_url, { ...FoxTheme.utils.fetchConfig('javascript'), body })
        .then((response) => response.json())
        .then((added) => this.publish(added))
        .catch((error) => console.error('hh-free-gift: could not add the gift', error))
        .finally(() => { busy = false; });
    }

    remove(line) {
      busy = true;
      const body = JSON.stringify({ line, quantity: 0, sections: this.sections() });
      fetch(FoxTheme.routes.cart_change_url, { ...FoxTheme.utils.fetchConfig(), body })
        .then((response) => response.json())
        .then((state) => FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart: state }))
        .catch((error) => console.error('hh-free-gift: could not remove the gift', error))
        .finally(() => { busy = false; });
    }

    /* /cart/add.js answers with the added lines only; the drawer wants the whole cart plus the sections. */
    async publish(added) {
      if (added.status) return;
      const cart = await (await fetch(FoxTheme.routes.cart_url, { ...FoxTheme.utils.fetchConfig() })).json();
      cart.sections = added.sections;
      FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, { cart });
    }
  }

  customElements.define('hh-free-gift', HHFreeGift);
})();
